import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/context/auth";
import { redirectToSso } from "src/lib/helpers";

interface ProtectedRouteProps {
  element: ReactElement;
}

export default function ProtectedRoute({ element }: ProtectedRouteProps) {
  const [state] = useAuth();
  const { user, loading } = state;

  if (loading) return null;

  if (!user) {
    redirectToSso();
    return;
  }

  return element;
}
